module.exports = __webpack_public_path__ + "static/water_glacier6-0873754e31366fd16c90c62112b3e9a6.jpg";